import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCatchRide = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9.14286 11.5H2.85714V4.35L6.85714 0.5L7.57143 1.1875C7.6381 1.25167 7.69295 1.33875 7.736 1.44875C7.77905 1.55875 7.80038 1.66417 7.8 1.765V1.9575L7.17143 4.35H10.8571C11.1619 4.35 11.4286 4.46 11.6571 4.68C11.8857 4.9 12 5.15667 12 5.45V6.55C12 6.61417 11.9905 6.68292 11.9714 6.75625C11.9524 6.82958 11.9333 6.89833 11.9143 6.9625L10.2 10.84C10.1143 11.0233 9.97143 11.1792 9.77143 11.3075C9.57143 11.4358 9.36191 11.5 9.14286 11.5ZM4 10.4H9.14286L10.8571 6.55V5.45H5.71429L6.48571 2.425L4 4.8175V10.4ZM2.85714 4.35V5.45H1.14286V10.4H2.85714V11.5H0V4.35H2.85714Z",
		fill: "#90A4AE"
	})]
});
const ForwardRef = forwardRef(SvgCatchRide);
export { ForwardRef as ReactComponent };
